import { jsx } from '@emotion/core'; // @ts-ignore

import { cross_16 } from '@trustpilot/icons';
import { Icon } from '../Icon';
import { tagStyles, removeIconStyles } from './styles';
export var Tags = function Tags(_a) {
  var _b = _a.items,
      items = _b === void 0 ? [] : _b,
      _c = _a.onRemove,
      onRemove = _c === void 0 ? function () {} : _c,
      _d = _a.readOnly,
      readOnly = _d === void 0 ? true : _d,
      children = _a.children;
  return jsx("div", {
    css: {
      display: 'flex',
      flexWrap: 'wrap',
      margin: -8
    }
  }, items.map(function (tag) {
    return jsx("span", {
      css: tagStyles,
      key: tag.key
    }, tag.text, readOnly ? null : jsx(Icon, {
      css: removeIconStyles,
      content: cross_16,
      onClick: function onClick() {
        return onRemove(tag);
      }
    }));
  }), children);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Tags/tags.js
// module id = 1194
// module chunks = 0